__turbopack_context__.v({
  "actionsRow": "LeftButtonTest-module__wn6e5a__actionsRow",
  "body": "LeftButtonTest-module__wn6e5a__body",
  "dragGrip": "LeftButtonTest-module__wn6e5a__dragGrip",
  "draggableItem": "LeftButtonTest-module__wn6e5a__draggableItem",
  "feedback": "LeftButtonTest-module__wn6e5a__feedback",
  "info": "LeftButtonTest-module__wn6e5a__info",
  "isActive": "LeftButtonTest-module__wn6e5a__isActive",
  "isDragging": "LeftButtonTest-module__wn6e5a__isDragging",
  "isDropTarget": "LeftButtonTest-module__wn6e5a__isDropTarget",
  "isFilled": "LeftButtonTest-module__wn6e5a__isFilled",
  "isSuccess": "LeftButtonTest-module__wn6e5a__isSuccess",
  "isSuccessDot": "LeftButtonTest-module__wn6e5a__isSuccessDot",
  "progressDot": "LeftButtonTest-module__wn6e5a__progressDot",
  "progressDots": "LeftButtonTest-module__wn6e5a__progressDots",
  "result-failed": "LeftButtonTest-module__wn6e5a__result-failed",
  "result-success": "LeftButtonTest-module__wn6e5a__result-success",
  "shell": "LeftButtonTest-module__wn6e5a__shell",
  "status-failed": "LeftButtonTest-module__wn6e5a__status-failed",
  "status-initial": "LeftButtonTest-module__wn6e5a__status-initial",
  "status-success": "LeftButtonTest-module__wn6e5a__status-success",
  "statusPill": "LeftButtonTest-module__wn6e5a__statusPill",
  "wrapper": "LeftButtonTest-module__wn6e5a__wrapper",
});
